// extracted by mini-css-extract-plugin
export var clickableWrapper = "_3a-2";
export var placeholderIcon = "_3a-3";
export var thumbnailCanvas = "_3a-1";
export var thumbnailWrapper = "_3a-0";